import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ParkPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#89479a', pt: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Container maxWidth="md">
        <Card sx={{ 
          backgroundColor: '#ffffff', 
          borderRadius: 4, 
          p: 8,
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          border: '1px solid rgba(0,0,0,0.06)'
        }}>
          <Box sx={{ mb: 4 }}>
            <img 
              src="/logo.png" 
              alt="Bloomaroot Logo" 
              style={{ 
                height: 200, 
                width: 'auto',
                marginBottom: 24
              }} 
            />
          </Box>
          
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#212121', mb: 3 }}>
            Bloomaroot is temporarily unavailable
          </Typography>
          
          <Typography variant="body1" sx={{ color: '#757575', mb: 4, lineHeight: 1.6 }}>
            We're currently performing updates to improve your experience. 
            Please check back soon for the full platform.
          </Typography>
          
          <Typography variant="body2" sx={{ color: '#757575', mb: 4, visibility: 'hidden' }}>
            For urgent inquiries, please contact our support team.
          </Typography>
          
          <Button 
            variant="contained" 
            color="primary"
            onClick={() => navigate('/contact')}
            sx={{ mt: 2, visibility: 'hidden' }}
          >
            Contact Support
          </Button>
        </Card>
      </Container>
    </Box>
  );
};

export default ParkPage;
